import React from "react";
import NormalAnswerDetail from "./answer_detail/NomalAnswerDetail";
import OtherAnswerDetail from "./answer_detail/OtherAnswerDetail";

const MultipleChoiceQuestionDetail = (props) => {
    const {testTypeId, question} = props;
    return (
        <React.Fragment>
            {question.answers.map((answer, index) => {
                if (answer.answerCode.search("other") !== -1)
                    return <OtherAnswerDetail answer={answer} index={index} key={index}
                                              questionType={question.questionType}/>;
                else
                    return <NormalAnswerDetail testTypeId={testTypeId} answer={answer} index={index} key={index}
                                               questionType={question.questionType}/>;
            })}
        </React.Fragment>
    );
};

export default MultipleChoiceQuestionDetail;